import { render, staticRenderFns } from "./CustomerDestiny.vue?vue&type=template&id=828dbb76&"
import script from "./CustomerDestiny.vue?vue&type=script&lang=js&"
export * from "./CustomerDestiny.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDestiny.vue?vue&type=style&index=0&id=828dbb76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports